import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';

import { WeightInput } from 'ui-components/components/weight-input';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { convertWeight } from '../../../../services/unit-services/weights/weight-convert-service';
import Global from '../../../../store/global-selectors';
import { CustomsField } from '../customs-field';
import commonStyle from '../common-style.module.less';
import messages from '../messages';
import type { WeightValue } from '../../../../prop-types/weight-types';
import type { WeightUnit } from '../../../../prop-types/weight-unit';

const UNKNOWN: WeightUnit = 'Unknown';

type CustomsWeightProps = {
  value: WeightValue;
  onChange: (weight: WeightValue) => void;
};

const debouncedOnChange = debounce((value: number, unit: WeightUnit, onChange: (weight: WeightValue) => void) => {
  onChange({
    value: value ?? 0,
    unit,
  });
}, 1000);

export const CustomsWeight: React.FC<CustomsWeightProps> = ({ onChange, value: weight }) => {
  const sellerWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const { value: initialWeightValue } = weight?.unit === UNKNOWN ? weight : convertWeight(weight, sellerWeightUnit);
  const [declaredWeightValue, setDeclaredWeightValue] = useAsyncSafeState(initialWeightValue);

  const handleWeightChange = (value: number, unit: WeightUnit) => {
    setDeclaredWeightValue(value);
    debouncedOnChange(value, unit, onChange);
  };

  return (
    <CustomsField label={messages.weightLabel}>
      <WeightInput
        className={commonStyle['weight-input']}
        onChange={handleWeightChange}
        unit={sellerWeightUnit}
        weight={declaredWeightValue}
      />
    </CustomsField>
  );
};
